// import React, { useEffect, useRef, useState } from 'react';
// import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
// import { FaExclamationTriangle, FaMicrophone } from "react-icons/fa";
//
// const Dictaphone1 = ({ isAccordionOpen, id, parameter, audioFiles, audioRef, onAudioEnded }) => {
//     const componentRef = useRef(null);
//     const [listening, setListening] = useState(false);
//     const [currentAudioIndex, setCurrentAudioIndex] = useState(0);
//     const [isPlaying, setIsPlaying] = useState(false);
//     const [isPlayingAll, setIsPlayingAll] = useState(false);
//     const [isFirstPlayed, setIsFirstPlayed] = useState(false);
//     const param2 = parameter;
//
//     const { resetTranscript } = useSpeechRecognition({
//         commands: [
//             { command: 'nästa steg', callback: () => isAccordionOpen && handleCommand('nästa steg') },
//             { command: 'första steg', callback: () => isAccordionOpen && handleCommand('första steg') },
//             { command: 'avsluta läsning', callback: () => { handleCommand('avsluta läsning'); stopListening(); }},
//             { command: 'läs alla steg', callback: () => isAccordionOpen && handleCommand('läs alla steg') },
//         ],
//     });
//
//     const handleCommand = (command) => {
//         console.log(`${command} command recognized: ${command}`);
//         if (listening) {
//             switch (command) {
//                 case 'nästa steg':
//                     nextAudioVoice();
//                     break;
//                 case 'första steg':
//                     playFirstAudioVoice();
//                     break;
//                 case 'avsluta läsning':
//                     stopAllAudio();
//                     stopListening(); // Stop listening after ending playback
//                     break;
//                 case 'läs alla steg':
//                     playAllAudio();
//                     stopListening(); // Stop listening when starting to read all
//                     break;
//                 default:
//                     console.log('Unrecognized voice command:', command);
//             }
//         } else {
//             console.log('Not listening, command ignored:', command);
//         }
//     };
//
//     const startListening = () => {
//         SpeechRecognition.startListening({ continuous: true, language: 'sv-SE' });
//         setListening(true);
//     };
//
//     const stopListening = () => {
//         SpeechRecognition.stopListening();
//         setListening(false);
//     };
//
//     const playAudio = () => {
//         if (audioFiles.length > 0 && audioRef.current && !isPlaying) {
//             console.log("Attempting to play audio at index:", currentAudioIndex, "src:", audioRef.current.src);
//             audioRef.current.play().then(() => {
//                 console.log("Playback started successfully.");
//                 setIsPlaying(true);
//             }).catch(error => console.error("Error playing audio:", error));
//         } else if (audioRef.current && isPlaying) {
//             console.log("Audio is already playing.");
//         } else if (audioFiles.length === 0) {
//             console.log("No audio files available.");
//         } else if (!audioRef.current) {
//             console.log("Audio ref not yet available.");
//         }
//     };
//
//     const pauseAudio = () => {
//         if (audioRef.current && isPlaying) {
//             console.log("Pausing audio.");
//             audioRef.current.pause();
//             setIsPlaying(false);
//         }
//     };
//
//     const nextAudioVoice = () => {
//         if (!isFirstPlayed) {
//             console.log("First 'nästa steg' command - playing first audio.");
//             if (audioRef.current) {
//                 audioRef.current.pause();
//             }
//             setCurrentAudioIndex(0);
//             if (audioRef.current && audioFiles.length > 0) {
//                 audioRef.current.src = audioFiles[0];
//                 audioRef.current.play()
//                     .then(() => {
//                         console.log("Playback started successfully for first audio via 'nästa steg'.");
//                         setIsPlaying(true);
//                         setIsFirstPlayed(true); // Mark that audio has now been played
//                     })
//                     .catch(error => console.error("Error playing first audio via 'nästa steg':", error));
//             }
//         } else {
//             if (audioRef.current) {
//                 audioRef.current.pause();
//             }
//             const newIndex = (currentAudioIndex + 1) % audioFiles.length;
//             setCurrentAudioIndex(newIndex);
//             if (audioRef.current && audioFiles.length > 0) {
//                 audioRef.current.src = audioFiles[newIndex];
//                 audioRef.current.play()
//                     .then(() => {
//                         console.log("Playback started successfully for next step.");
//                         setIsPlaying(true);
//                     })
//                     .catch(error => console.error("Error playing next audio:", error));
//             }
//         }
//     };
//
//     const playFirstAudioVoice = () => {
//         if (audioFiles.length > 0 && audioRef.current) {
//             console.log("Playing first audio.");
//             audioRef.current.pause();
//             setCurrentAudioIndex(0);
//             audioRef.current.src = audioFiles[0];
//             setIsPlaying(true); // Forcefully set isPlaying to true when starting
//             audioRef.current.play()
//                 .catch(error => console.error("Error playing first audio:", error));
//             setIsFirstPlayed(true);
//         } else {
//             console.log("Conditions not met to play first audio.");
//             console.log("audioFiles.length:", audioFiles.length > 0);
//             console.log("audioRef.current:", !!audioRef.current);
//         }
//     };
//
//
//
//     const playAllAudio = () => {
//         setIsPlayingAll(true);
//         setCurrentAudioIndex(0);
//         console.log("Playing all audio starting from index 0.");
//         if (audioFiles.length > 0 && audioRef.current) {
//             audioRef.current.src = audioFiles[0];
//             audioRef.current.play().catch(error => console.error("Error playing all audio:", error));
//             setIsPlaying(true);
//         }
//     };
//
//     // const handleAudioEndedInternal = () => {
//     //     console.log("Audio playback ended - handleAudioEndedInternal called.");
//     //     setIsPlaying(false);
//     //     if (isPlayingAll) {
//     //         const nextIndex = currentAudioIndex + 1;
//     //         if (nextIndex < audioFiles.length) {
//     //             setCurrentAudioIndex(nextIndex);
//     //             if (audioRef.current) {
//     //                 console.log("Playing next in 'play all' mode. Index:", nextIndex, "src:", audioFiles[nextIndex]);
//     //                 audioRef.current.src = audioFiles[nextIndex];
//     //                 audioRef.current.play().catch(error => console.error("Error playing all audio:", error));
//     //                 setIsPlaying(true);
//     //             }
//     //         } else {
//     //             console.log("End of audio queue in 'play all' mode - stopping all.");
//     //             stopAllAudio();
//     //         }
//     //     }
//     //     if (onAudioEnded) {
//     //         onAudioEnded(); // Notify the parent component if needed
//     //     }
//     // };
//     const handleAudioEndedInternal = () => {
//         console.log("Audio playback ended - handleAudioEndedInternal called.");
//         setIsPlaying(false);
//         if (isPlayingAll) {
//             const nextIndex = currentAudioIndex + 1;
//             if (nextIndex < audioFiles.length) {
//                 setCurrentAudioIndex(nextIndex);
//                 // Introduce a 1-second delay before playing the next track
//                 setTimeout(() => {
//                     if (audioRef.current && isPlayingAll && currentAudioIndex === nextIndex) {
//                         console.log("Playing next in 'play all' mode after delay. Index:", nextIndex, "src:", audioFiles[nextIndex]);
//                         audioRef.current.src = audioFiles[nextIndex];
//                         audioRef.current.play().catch(error => console.error("Error playing all audio:", error));
//                         setIsPlaying(true);
//                     }
//                 }, 3000); // 1000 milliseconds = 1 second
//             } else {
//                 console.log("End of audio queue in 'play all' mode - stopping all.");
//                 stopAllAudio();
//             }
//         }
//         if (onAudioEnded) {
//             onAudioEnded(); // Notify the parent component if needed
//         }
//     };
//     const stopAllAudio = () => {
//         if (audioRef.current) {
//             console.log("Stopping all audio.");
//             audioRef.current.pause();
//         }
//         console.log("Setting isPlaying to false in stopAllAudio.");
//         setIsPlaying(false);
//         console.log("Setting isPlayingAll to false in stopAllAudio.");
//         setIsPlayingAll(false);
//         console.log("Setting currentAudioIndex to 0 in stopAllAudio.");
//         setCurrentAudioIndex(0);
//     };
//
//     useEffect(() => {
//         if (audioRef.current) {
//             audioRef.current.addEventListener('ended', handleAudioEndedInternal);
//             return () => {
//                 if (audioRef.current) {
//                     audioRef.current.removeEventListener('ended', handleAudioEndedInternal);
//                 }
//             };
//         }
//     }, [audioRef, isPlayingAll, currentAudioIndex, audioFiles, stopAllAudio]);
//
//
//
//
//
//     useEffect(() => {
//         const handleBlur = () => listening && stopListening();
//         window.addEventListener('blur', handleBlur);
//
//         const observer = new IntersectionObserver(
//             ([entry]) => {
//                 if (!entry.isIntersecting && listening) stopListening();
//             },
//             { threshold: 0.1 }
//         );
//
//         if (componentRef.current) observer.observe(componentRef.current);
//
//         return () => {
//             window.removeEventListener('blur', handleBlur);
//             if (componentRef.current) observer.unobserve(componentRef.current);
//         };
//     }, [listening, stopListening]);
//
//     useEffect(() => {
//         if (isPlayingAll) {
//             if (currentAudioIndex < audioFiles.length && audioRef.current) {
//                 console.log("Playing next in 'play all' mode. Index:", currentAudioIndex);
//                 audioRef.current.src = audioFiles[currentAudioIndex];
//                 audioRef.current.play().catch(error => console.error("Error playing all audio:", error));
//                 setIsPlaying(true);
//             } else {
//                 console.log("End of audio queue in 'play all' mode.");
//                 stopAllAudio();
//             }
//         }
//     }, [currentAudioIndex, isPlayingAll, audioFiles, audioRef, stopAllAudio]);
//
//
//     const handleMicButtonClick = () => {
//         if (isPlayingAll) {
//             stopAllAudio(); // Stop the reading
//             resetTranscript(); // Clear any ongoing transcript
//             startListening(); // Start listening for new commands
//             return;
//         }
//
//         // Normal listening toggle
//         if (listening) {
//             stopListening();
//         } else {
//             resetTranscript();
//             startListening();
//         }
//     };
//
//     return (
//         <div ref={componentRef} className='center container mt-32 pb-32'>
//             <div className="mt-8">
//                 <div className="warning">
//                     <FaExclamationTriangle className="warning-icon" />
//                     <p>Test version</p>
//                 </div>
//                 <p style={{ fontSize: '14pt', color: '#54319f' }}>Innan du börjar med rösttyrning läs igenom instruktioner nedan</p>
//                 <h4 className="command-header pt-8" style={{ fontSize: '14pt', color: '#54319f' }}> <b>A.</b> Tala alltid högt och tydligt</h4>
//                 <h4 className="command-header pt-8 " style={{ fontSize: '14pt', color: '#54319f' }}><b>B. </b> Det går inte att röststyra samtidigt som instruktioner läsas upp. </h4>
//                 <h4 className="command-header pt-8 " style={{ fontSize: '14pt', color: '#54319f' }}><b>C. </b> Tillgängliga röstkommandon:</h4>
//                 <p className="command pt-8">1. Första steg</p>
//                 <p className="command">2. Nästa steg</p>
//                 <p className="command">3. Läs alla steg</p>
//
//                 <button className='ghostbuttonround cols pt-16'
//                         onClick={handleMicButtonClick}
//                         id={id}
//                 >
//                     <FaMicrophone
//                         style={{
//                             fontSize: '24pt',
//                             color: listening ? '#9F316DFF' : '#54319f'
//                         }}
//                     />
//                     <p style={{ fontSize: '14pt', color: listening ? '#9F316DFF' : '#54319f' }}>
//                         {listening ? 'Avsluta' : 'Starta'} röststyrning
//                     </p>
//                 </button>
//             </div>
//         </div>
//     );
// };
//
// export default Dictaphone1;




import React, { useEffect, useRef, useState } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { FaExclamationTriangle, FaMicrophone, FaSpeakerDeck, FaVolumeUp } from "react-icons/fa";

const Dictaphone1 = ({ isAccordionOpen, id, parameter, audioFiles, audioRef, onAudioEnded }) => {
    const componentRef = useRef(null);
    const isPlayingAllRef = useRef(false);
    const currentAudioIndexRef = useRef(0);
    const [listening, setListening] = useState(false);
    const [currentAudioIndex, setCurrentAudioIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isPlayingAll, setIsPlayingAll] = useState(false);
    const [isFirstPlayed, setIsFirstPlayed] = useState(false);
    const param2 = parameter;

    const { resetTranscript } = useSpeechRecognition({
        commands: [
            { command: 'nästa steg', callback: () => isAccordionOpen && handleCommand('nästa steg') },
            { command: 'första steg', callback: () => isAccordionOpen && handleCommand('första steg') },
            { command: 'avsluta läsning', callback: () => { handleCommand('avsluta läsning'); stopListening(); } },
            { command: 'läs alla steg', callback: () => isAccordionOpen && handleCommand('läs alla steg') },
        ],
    });

    const handleCommand = (command) => {
        console.log(`${command} command recognized: ${command}`);
        if (listening) {
            switch (command) {
                case 'nästa steg':
                    nextAudioVoice();
                    break;
                case 'första steg':
                    playFirstAudioVoice();
                    break;
                case 'avsluta läsning':
                    stopAllAudio();
                    stopListening(); // Stop listening after ending playback
                    break;
                case 'läs alla steg':
                    playAllAudio();
                    stopListening(); // Stop listening when starting to read all
                    break;
                default:
                    console.log('Unrecognized voice command:', command);
            }
        } else {
            console.log('Not listening, command ignored:', command);
        }
    };

    const startListening = () => {
        SpeechRecognition.startListening({ continuous: true, language: 'sv-SE' });
        setListening(true);
    };

    const stopListening = () => {
        SpeechRecognition.stopListening();
        setListening(false);
    };

    const playAudio = () => {
        if (audioFiles.length > 0 && audioRef.current && !isPlaying) {
            console.log("Attempting to play audio at index:", currentAudioIndex, "src:", audioRef.current.src);
            audioRef.current.play().then(() => {
                console.log("Playback started successfully.");
                setIsPlaying(true);
            }).catch(error => console.error("Error playing audio:", error));
        } else if (audioRef.current && isPlaying) {
            console.log("Audio is already playing.");
        } else if (audioFiles.length === 0) {
            console.log("No audio files available.");
        } else if (!audioRef.current) {
            console.log("Audio ref not yet available.");
        }
    };

    const pauseAudio = () => {
        if (audioRef.current && isPlaying) {
            console.log("Pausing audio.");
            audioRef.current.pause();
            setIsPlaying(false);
        }
    };

    const nextAudioVoice = () => {
        if (!isFirstPlayed) {
            console.log("First 'nästa steg' command - playing first audio.");
            if (audioRef.current) {
                audioRef.current.pause();
            }
            setCurrentAudioIndex(0);
            if (audioRef.current && audioFiles.length > 0) {
                audioRef.current.src = audioFiles[0];
                audioRef.current.play()
                    .then(() => {
                        console.log("Playback started successfully for first audio via 'nästa steg'.");
                        setIsPlaying(true);
                        setIsFirstPlayed(true); // Mark that audio has now been played
                    })
                    .catch(error => console.error("Error playing first audio via 'nästa steg':", error));
            }
        } else {
            if (audioRef.current) {
                audioRef.current.pause();
            }
            const newIndex = (currentAudioIndex + 1) % audioFiles.length;
            setCurrentAudioIndex(newIndex);
            if (audioRef.current && audioFiles.length > 0) {
                audioRef.current.src = audioFiles[newIndex];
                audioRef.current.play()
                    .then(() => {
                        console.log("Playback started successfully for next step.");
                        setIsPlaying(true);
                    })
                    .catch(error => console.error("Error playing next audio:", error));
            }
        }
    };

    const playFirstAudioVoice = () => {
        if (audioFiles.length > 0 && audioRef.current) {
            console.log("Playing first audio.");
            audioRef.current.pause();
            setCurrentAudioIndex(0);
            audioRef.current.src = audioFiles[0];
            setIsPlaying(true); // Forcefully set isPlaying to true when starting
            audioRef.current.play()
                .catch(error => console.error("Error playing first audio:", error));
            setIsFirstPlayed(true);
        } else {
            console.log("Conditions not met to play first audio.");
            console.log("audioFiles.length:", audioFiles.length > 0);
            console.log("audioRef.current:", !!audioRef.current);
        }
    };



    const playAllAudio = () => {
        setIsPlayingAll(true);
        isPlayingAllRef.current = true;
        setCurrentAudioIndex(0);
        currentAudioIndexRef.current = 0;
        console.log("Playing all audio starting from index 0.");
        if (audioFiles.length > 0 && audioRef.current) {
            audioRef.current.src = audioFiles[0];
            audioRef.current.play().catch(error => console.error("Error playing all audio:", error));
            setIsPlaying(true);
        }
    };

    const handleAudioEndedInternal = () => {
        console.log("Audio playback ended - handleAudioEndedInternal called.");
        console.log("isPlayingAllRef.current:", isPlayingAllRef.current, "currentAudioIndexRef.current:", currentAudioIndexRef.current);
        setIsPlaying(false);

        if (isPlayingAllRef.current) {
            const nextIndex = currentAudioIndexRef.current + 1;
            console.log("Next index:", nextIndex, "Total files:", audioFiles.length);

            if (nextIndex < audioFiles.length) {
                // Update ref immediately to prevent loop
                currentAudioIndexRef.current = nextIndex;
                setCurrentAudioIndex(nextIndex);

                // Introduce a delay before playing the next track
                setTimeout(() => {
                    if (audioRef.current && isPlayingAllRef.current) {
                        console.log("Playing next in 'play all' mode after delay. Index:", nextIndex, "src:", audioFiles[nextIndex]);
                        setCurrentAudioIndex(nextIndex);
                        audioRef.current.src = audioFiles[nextIndex];
                        audioRef.current.load();
                        audioRef.current.play()
                            .then(() => {
                                console.log("Successfully playing audio at index:", nextIndex);
                                setIsPlaying(true);
                            })
                            .catch(error => {
                                console.error("Error playing all audio:", error);
                                stopAllAudio();
                            });
                    } else {
                        console.log("Playback stopped during delay.");
                        stopAllAudio();
                    }
                }, 1500);
            } else {
                console.log("End of audio queue in 'play all' mode - stopping all.");
                stopAllAudio();
            }
        }

        if (onAudioEnded) {
            onAudioEnded();
        }
    };

    const stopAllAudio = () => {
        if (audioRef.current) {
            console.log("Stopping all audio.");
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current.src = '';
            audioRef.current.load();
        }
        console.log("Setting isPlaying to false in stopAllAudio.");
        setIsPlaying(false);
        console.log("Setting isPlayingAll to false in stopAllAudio.");
        setIsPlayingAll(false);
        isPlayingAllRef.current = false;
        console.log("Setting currentAudioIndex to 0 in stopAllAudio.");
        setCurrentAudioIndex(0);
        currentAudioIndexRef.current = 0;
    };

    useEffect(() => {
        const currentAudioRef = audioRef.current; // Capture current value

        // Create handler functions that can be properly removed
        const handlePlay = () => setIsPlaying(true);
        const handlePause = () => setIsPlaying(false);

        if (currentAudioRef) {
            currentAudioRef.addEventListener('ended', handleAudioEndedInternal);
            currentAudioRef.addEventListener('play', handlePlay);
            currentAudioRef.addEventListener('pause', handlePause);

            return () => {
                if (currentAudioRef) {
                    currentAudioRef.removeEventListener('ended', handleAudioEndedInternal);
                    currentAudioRef.removeEventListener('play', handlePlay);
                    currentAudioRef.removeEventListener('pause', handlePause);
                }
            };
        }
    }, [audioRef]); // Removed handleAudioEndedInternal from dependencies to prevent re-subscription loop


    useEffect(() => {
        const handleBlur = () => listening && stopListening();
        const currentComponentRef = componentRef.current; // Capture ref value

        window.addEventListener('blur', handleBlur);

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting && listening) stopListening();
            },
            { threshold: 0.1 }
        );

        if (currentComponentRef) observer.observe(currentComponentRef);

        return () => {
            window.removeEventListener('blur', handleBlur);
            if (currentComponentRef) observer.unobserve(currentComponentRef);
        };
    }, [listening]); // Removed stopListening from dependencies as it's defined in component scope

    // Removed the useEffect that triggered on currentAudioIndex change
    // Reverted to the logic within handleAudioEndedInternal as per user's provided code structure.


    const handleMicButtonClick = () => {
        if (isPlayingAll) {
            stopAllAudio(); // Stop the reading
            // Removed resetTranscript as per user's request
            startListening(); // Start listening for new commands
            return;
        }

        // Normal listening toggle
        if (listening) {
            stopListening();
        } else {
            // Removed resetTranscript as per user's request
            startListening();
        }
    };

    return (
        <div ref={componentRef} className='center container mt-32 pb-32'>
            {/* Make this the flex container for vertical arrangement */}
            <div className="mt-8" style={{ display: 'flex', flexDirection: 'column' }}>

                <p className={'h3 pt-32 '}>     <FaVolumeUp /></p>
                <p className={'pb-32 h3 '}> Ljudinstruktioner</p>

                <div className="warning">
                    <FaExclamationTriangle className="warning-icon" />
                    <p>Test version</p>
                </div>
                <div className='left m-16'>

                    <p style={{ fontSize: '14pt', color: '#54319f' }}>Innan du börjar med rösttyrning läs igenom instruktioner nedan</p>
                    <h4 className="command-header pt-8" style={{ fontSize: '14pt', color: '#54319f' }}> <b>A.</b> Tala alltid högt och tydligt</h4>
                    <h4 className="command-header pt-8 " style={{ fontSize: '14pt', color: '#54319f' }}><b>B. </b> Det går inte att röststyra samtidigt som instruktioner läsas upp. </h4>
                    <h4 className="command-header pt-8 " style={{ fontSize: '14pt', color: '#54319f' }}><b>C. </b> Tillgängliga röstkommandon:</h4>

                </div>
                {/* This div will be vertically centered */}
                <div style={{ margin: 'auto', textAlign: 'left' }}> {/* Added textAlign: 'left' */}
                    <p>1. Första steg</p>
                    <p>2. Nästa steg</p>
                    <p>3. Läs alla steg</p>
                </div>
                <div className={"center"}>
                    <button className='ghostbuttonround cols pt-16'
                        onClick={handleMicButtonClick}
                        id={id}
                    >
                        <FaMicrophone
                            style={{
                                fontSize: '24pt',
                                color: listening ? '#9F316DFF' : '#54319f'
                            }}
                        />
                        <p style={{ fontSize: '14pt', color: listening ? '#9F316DFF' : '#54319f' }}>
                            {listening ? 'Avsluta' : 'Starta'} röststyrning
                        </p>
                    </button>
                </div>

            </div> {/* End of flex container div */}
        </div>
    );

};

export default Dictaphone1;